import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auth, createUserWithEmailAndPassword, updateProfile, User } from '@angular/fire/auth';
import { Firestore, collectionData, collection, addDoc, doc, updateDoc, query, where, getDocs, getDoc, setDoc, DocumentSnapshot, DocumentData, docData, DocumentReference } from '@angular/fire/firestore';
import { _ } from 'ajv';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';
import * as moment from 'moment';
import { forkJoin, merge, Observable, Subject } from 'rxjs';
import { IAnneeAcademique, IModule } from 'src/app/interfaces/academic-years';
import { IPersonne } from 'src/app/interfaces/etudiant';
import { IHomeWork } from 'src/app/interfaces/home-work';
import { IUser } from 'src/app/model/user';
import { ModuleService } from '../modules/module.service';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    public downloadError = new Subject();
    constructor(public module: ModuleService, public firestore: Firestore, private http: HttpClient) { }


    /**
     * 
     * @returns 
     */
    public getUsers(): Observable<IUser[]> {
        const userCollection = collection(this.firestore, 'request-study');
       // const promotion:number = (new Date()).getFullYear();
       const promotion:number = 2025;

        const q = query(userCollection,where("promotion", "==", promotion),);
        return collectionData(q) as Observable<IUser[]>;

    }

    /**
    * 
    * @returns 
    */
    public getUserFromEmail(email): Observable<IUser[]> {
        const userCollection = collection(this.firestore, "Etudiants");
        const q = query(userCollection, where("email", "==", email));
        return collectionData(q) as Observable<IUser[]>;

    }


    async getStudentByEmail(email: string) {
        const etudiantRef = doc(this.firestore, `Etudiants/${email}`);
        const etudiantSnap = await getDoc(etudiantRef);
        if (etudiantSnap.exists()) {
            return etudiantSnap.data() as IPersonne;
        } else {
            throw new Error('Etudiant non trouvé');
        }
    }

    /**
  * Download the course
  * 
  * @param collectionPath 
  * @param item
  * @param isWord
  */
    public downloadFileControle(data) {
        const storage = getStorage();
        let filePath = `evaluations/${data.level}/${data.filename}`;

        getDownloadURL(ref(storage, filePath))
            .then((url) => {
                this.http.get(url, {
                    responseType: 'blob'
                }).subscribe(blob => {
                    const a = document.createElement('a')
                    const objectUrl = URL.createObjectURL(blob)
                    a.href = objectUrl
                    a.download = data.filename;
                    a.click();
                    URL.revokeObjectURL(objectUrl);
                })
            })
            .catch((error) => {
                console.log(error)
                this.downloadError.next("Impossible de télécharger le document, veuillez contacter l'administrateur du site.");
                this.downloadError.complete();
            });
    }

    public async getAllLevelFromEmail(email) {
        const year = "2025";
        // const year = (new Date()).getFullYear();
        const userCollectionLevel1 = collection(this.firestore, `/students/${year}/level1`);
        const q = query(userCollectionLevel1, where("email", "==", email));

        const userCollectionLevel2 = collection(this.firestore, `/students/${year}/level2`);
        const q1 = query(userCollectionLevel2, where("email", "==", email));
        const user1 = collectionData(q) as Observable<IUser[]>;
        const user2 = collectionData(q1) as Observable<IUser[]>;

        return merge(user1, user2);
    }

    public async getLevelFromEmail(email, level) {
        const year = "2025";
        const userCollectionLevel1 = collection(this.firestore, `/students/${year}/${level}`);
        const q = query(userCollectionLevel1, where("email", "==", email));
        const querySnapshot = await getDocs(q);
        return querySnapshot.size;
    }

    /**
     * 
     * @returns 
     */
    public getUsersAccepted(level): Observable<IUser[]> {

       // const year = (new Date()).getFullYear();
        const year = "2025";
        return collectionData(collection(this.firestore, `/students/${year}/level${level}`)) as Observable<IUser[]>;

    }

    async changerStatutAnnee(emailEtudiant: string, idAnnee: string, nouveauStatut: string): Promise<void> {
        const anneeRef = doc(this.firestore, `Etudiants/${emailEtudiant}/Annees/${idAnnee}`);
        await updateDoc(anneeRef, { statut: nouveauStatut });
    }


    getStatutAnnee(emailEtudiant: string, idAnnee: string, nouveauStatut: string): Observable<IAnneeAcademique> {
        const anneeRef = doc(this.firestore, `Etudiants/${emailEtudiant}/Annees/${idAnnee}`);
        return docData(anneeRef) as Observable<IAnneeAcademique>;
    }

    /**
     * 
     * @param data 
     * @param level 
     * @returns 
     */
    public getUserInfoFromEmail(data, level) {
        //const year:string = ''+(new Date()).getFullYear();
        const year = "2025";
        return this.module.getYearInprogress(data.email).then(async years=> {
            console.log(`/Etudiants/${data.email}/Annees/${year}/Devoirs`)
            const docRef = collection(this.firestore, `/Etudiants/${data.email}/Annees/${year}/Devoirs`);
            const docSnap = await getDocs(docRef);

            return { doc: [...docSnap.docs].map(doc => doc.data()), year: year };
        })


    }


    /**
   * 
   * @param user 
   * @returns 
   */
    public async saveUser(user) {
        //const q = query(userCollection, where("level", "==", "2"),
        //  where("inscriptionConfirmed", "==", true));
        let y = 0;

         

                const etudiantRef: DocumentReference<DocumentData> = doc(this.firestore, `Etudiants/${user.email}`);
                const docSnapshot = await getDoc(etudiantRef);


                var work: IHomeWork[] = [];
              
                if (!docSnapshot.exists()) {

                    const etud: IPersonne = {
                        nom: user.name,
                        prenom: user.firstname,
                        email: user.email,
                        phone: user.phone,
                        pays: user.country ? user.country : "France"
                    }
                    console.log("-----ETUD")
                    console.log(etud)


                    const annee: IAnneeAcademique = {
                        inscriptionConfirmed: true,
                        dateInscription: user.date,
                        status: "en cours"
                    }
                    console.log(annee)


                     if(!user.inscriptionConfirmed){
                    this.addStudent(etud, "2025", work, annee).then(x=>console.log(x));
                     }
                }
               


  

    }

    /**
   * 
   * @param user 
   * @returns 
   */
    public async saveUsers(level) {
        const userCollection = collection(this.firestore, '/students/2023/level2');
        //const q = query(userCollection, where("level", "==", "2"),
        //  where("inscriptionConfirmed", "==", true));
        let users = collectionData(userCollection, { idField: 'docId' });
        let y = 0;
        users.subscribe((x: any[]) => {

            let c = x.map(async x => {

                const etudiantRef: DocumentReference<DocumentData> = doc(this.firestore, `Etudiants/${x.email}`);
                const docSnapshot = await getDoc(etudiantRef);


                var work: IHomeWork[] = [];
                for (let i in x["controles"]) {




                    work.push({
                        doc: x["controles"][i]["doc"] ? x["controles"][i]["doc"] : "",
                        filename: x["controles"][i]["filename"],
                        level: x["controles"][i]["level"],
                        note: x["controles"][i]["note"]
                    });




                }
                if (!docSnapshot.exists()) {

                    const etud: IPersonne = {
                        nom: x.name,
                        prenom: x.firstname,
                        email: x.email,
                        phone: x.phone,
                        pays: x.country ? x.country : "France"
                    }


                    const annee: IAnneeAcademique = {
                        inscriptionConfirmed: x.inscriptionConfirmed,
                        dateInscription: x.date,
                        dateSentMail: x.dateSentMail,
                        status: "en cours"
                    }
                    console.log("-------------1-------------")

                    // this.addStudent(etud, "2023", work, annee);
                }
                else {
                    //this.addWork(x.email, "2023", work)
                    console.log("-------------2-------------")
                    console.log(x.email)


                }


                return x;


            });



            // const notesRef = collection(this.firestore, '/students/2023/level2');
            //setDoc(doc(notesRef, x[i]["email"]), x[i]).then(x => { })
            console.log(c);


        }, error => { console.log(error) })

    }


    // async ajouterEtudiantAvecCollections(email: string, etudiant: Etudiant, annee: string, devoirs: Devoir[], module: Module) {

    //  }

    /**
* 
* @param user 
* @returns 
*/
    public async modules() {

        const docRef = collection(this.firestore, "/modules/2024/level1")
        //doc(this.firestore, "/modules/2023/level4");
        let users = collectionData(docRef);
        // { idField: 'docId' }

        users.subscribe((x: any[]) => {

            console.log(x)




            for (let i in x[0]) {

                x[0][i]["unlocked"] = false;
                console.log(x[0][i]);

            }

            const level1Ref = collection(this.firestore, '/modules/2025/level1');
             addDoc(level1Ref, x[0]).then(x => {

              console.log(x)
             }, error => console.log(error));

        }
        );
        //const docSnap = await getDoc(docRef);


        // if (docSnap.exists()) {
        //     let data = docSnap.data()
        //     console.log(docSnap.data()[0]);

        //     for (let i in data) {

        //         data[i]["unlocked"] = false;

        //     }
        //     console.log(data);
        //     const level1Ref = collection(this.firestore, '/modules/2024/level1');
        //     addDoc(level1Ref, data).then(x => {

        //         console.log(x)
        //     }, error => console.log(error));
        // }



    }

    async addStudent(student: IPersonne, year: string, work: any[] = [], yearDoc) {

        // let work = [];



        // Ajouter l'étudiant
        // on ajoute un document
        const etudiantRef = doc(this.firestore, `Etudiants/${student.email}`);
        await setDoc(etudiantRef, student);

        // Ajouter la collection d'année
        const anneeRef = collection(this.firestore, `Etudiants/${student.email}/Annees`);

        //on fixe le nom du document auquel on va ajouter des champs
        const anneeDocRef = doc(anneeRef, year);
        await setDoc(anneeDocRef, yearDoc);

        // Ajouter le document de devoirs
        const devoirsRef = collection(this.firestore, `Etudiants/${student.email}/Annees/${year}/Devoirs`);
        for (const devoir of work) {
            //génration des Id de chaque document en rajouter le devoir
            await addDoc(devoirsRef, devoir);
        }
    }

    async addWork(emailEtudiant: string, idAnnee: string, work: IHomeWork[]): Promise<void> {
        const devoirRef = collection(this.firestore, `Etudiants/${emailEtudiant}/Annees/${idAnnee}/Devoirs`);

        for (const devoir of work) {
            //génration des Id de chaque document en rajouter le devoir
            await addDoc(devoirRef, devoir);
        }
        //await addDoc(devoirRef, devoir);
    }

    //williams.abanda-djoh@outlook.com
    getStudentWorks(email: string, year: string): Observable<IHomeWork[]> {
        // Ajouter le document de devoirs
        const devoirsRef = collection(this.firestore, `Etudiants/${email}/Annees/${year}/Devoirs`);
        return collectionData(devoirsRef) as Observable<IHomeWork[]>

    }

    // Obtenir les informations d'un étudiant
    getStudentDetail(email: string): Observable<IPersonne> {
        const etudiantRef = doc(this.firestore, `/Etudiants/${email}`);
        return docData(etudiantRef) as Observable<IPersonne>;
    }


    // Obtenir les informations d'un étudiant
    getAllStudents(year): Observable<IPersonne[]> {
        const etudiantRef = collection(this.firestore, `/Etudiants`);
        return collectionData(etudiantRef) as Observable<IPersonne[]>;
    }


    // Ajouter un nouvel étudiant
    ajouterEtudiant(etudiant: IPersonne): Promise<void> {
        const etudiantRef = doc(this.firestore, `Etudiants/${etudiant.email}`);
        return setDoc(etudiantRef, etudiant);
    }

    // Ajouter une année académique à un étudiant
    ajouterAnneeAcademique(emailEtudiant: string, anneeAcademique: IAnneeAcademique) {
        // const anneeRef = doc(this.firestore, `Etudiants/${emailEtudiant}/Annees/${anneeAcademique.anneeId}`);
        //return setDoc(anneeRef, anneeAcademique);
    }

    // Ajouter un cours à une année académique spécifique d'un étudiant
    ajouterCours(emailEtudiant: string, anneeId: string, cours: IModule): Promise<void> {
        const coursRef = doc(this.firestore, `Etudiants/${emailEtudiant}/Annees/${anneeId}/Modules/${cours.id}`);
        return setDoc(coursRef, cours);
    }

    // Utilisation de la fonction
    /*ajouterEtudiant({
      nom: 'Dupont',
      prenom: 'Jean',
      email: 'jean.dupont@example.com',
      dateInscription: '2024-01-28', // Date au format YYYY-MM-DD
      autresInfos: {
        departement: 'Informatique'
      }
    });*/


    public async save() {
        const userCollection = collection(this.firestore, 'request-study');
        const q = query(userCollection, where("level", "==", "2"),
            where("inscriptionConfirmed", "==", true));
        let users = collectionData(q) as Observable<IUser[]>;
        users.subscribe(x => {

            for (let i in x) {

                const notesRef = collection(this.firestore, '/students/2023/level2');
                setDoc(doc(notesRef, x[i]["email"]), x[i]).then(x => { })
            }

        }, error => { console.log(error) })

    }



    public createAccount(auth: Auth) {
        const userCollection = collection(this.firestore, 'request-study');
        const q = query(userCollection,
            where("inscriptionConfirmed", "==", true));
        let users = collectionData(q) as Observable<IUser[]>;
        users.subscribe(x => {
            for (let i in x) {

            }

        }, error => { console.log(error) })

    }

    /**
     * 
     * @param user 
     * @returns 
     */
    public async update(user: any) {
        const userCollection = collection(this.firestore, `request-study`);
        const q = query(userCollection, where("email", "==", user.email));
        const querySnapshot = await getDocs(q);
        let id;
        querySnapshot.forEach((doc) => {
            id = doc.id;
        });

        const noteDocRef = doc(this.firestore, `request-study/${id}`);
        return updateDoc(noteDocRef, { inscriptionConfirmed: true, dateSentMail: moment(new Date()).format('DD/MM/YYYY') });

    }




    /**
   * 
   * @param data 
   * @returns 
   */
    studentAccepted(user: IUser) {
    return new Observable(observer =>{
          
          const etudiantRef = doc(this.firestore, `Etudiants/${user.email}`);
          setDoc(etudiantRef, {inscriptionConfirmed: true}).then(() =>{
            console.log("ok");
          },(error) => {
            console.error("Erreur lors de l'écriture :", error);
          }); 
    })
}



}
